import React, {Component} from 'react';
import {
    View,
    StatusBar,
    Image,
    TextInput,
    Text,

    BackHandler,
    Alert,
    TouchableOpacity,
    Platform,
    KeyboardAvoidingView,
    ScrollView
} from "react-native"

import {verticalScale, moderateScale, scale} from "../../../../tools/Scaling";
import {AsyngStorageClass} from '../../../../tools/AsyngStorageClass';
import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import Colors from "../../../../tools/Colors";
import HMTextView from "../../../../customviews/HMTextView";
import DialogLoadingCustomize from "../../../../customviews/DialogLoadingCustomize";
import HMActionBar from "../../../../customviews/HMActionBar";
import i18n from "../../../../I18n/i18n";
import HMTextInputEfects from "../../../../customviews/HMTextInputEfects";
import {typeExport} from "../../../../redux/store/type";
import {Tools} from "../../../../tools/Tools";
import PathFile from "../../../../assets/PathFile";
import store from "../../../../redux/store";
import HMAlert from "../../../../customviews/HMAlert";

export default class InformationScreen extends Component {

    constructor(props) {
        super(props)
        this.state = {
            NationalCode: {
                value: '',
                error: ''
            },
            FirstName: {
                value: '',
                error: ''
            },
            LastName: {
                value: '',
                error: ''
            },
            Password: {
                value: '',
                error: ''
            },
            ConfirmPassword: {
                value: '',
                error: ''
            },
            checked: false,
            indexSelectGender: 1

        }
        props.callServiceRefresh();
    }

    componentDidMount() {
        BackHandler.addEventListener('hardwareBackPress', this.handleBackPress);
    }

    componentWillUnmount() {
        BackHandler.removeEventListener('hardwareBackPress', this.handleBackPress);
    }

    handleBackPress = () => {
        this.goBack(); // works best when the goBack is async
        return true;
    }

    goBack() {

        this.props.navigation.pop();


        // switch (this.props.route.params.type_login) {
        //
        //     case "fav":
        //         this.props.navigation.navigate("MainScreen");
        //         break;
        // }

    }

    componentWillReceiveProps(propss) {
        /*     if (propss.results != null) {
                 //   this.loadingButton.showLoading(false);

                 if (propss.results.status == true) {
                     this.props.callServiceSetToken(propss.results.user.token);
                     this.props.callServiceSetUser(propss.results.user),

                         this.setInfoUser(
                             propss.results.user.token,
                             propss.results.user.Password,
                             propss.results.user.name,
                             this.props.route.params.mobile,
                         )
                 } else {
                     alert(propss.results.message)

                 }
             }*/
    }

    async setInfoUser(token, Password, name, mobile) {

        let value1 = await AsyngStorageClass.setInfoUser(token, Password, name);
        let value2 = await AsyngStorageClass.setInfoUserMobile(mobile);

        if (value1 & value2) {

            this.props.navigation.pop();

            switch (this.props.route.params.type_login) {
                case "changeInfo":
                    this.props.navigation.navigate("ChangeInformationScreen");
                    break;

                default:
                    this.props.navigation.navigate("SplashScreen", {refreshOfLogin: true});
                //this.props.navigation.pop();
            }
        } else {
            this.props.navigation.pop();
            alert(i18n.t('constant.Try_again'))
        }
    }

    getData() {
        let {FirstName, LastName, Password, ConfirmPassword, checked, NationalCode} = this.state
        let paramss = {
            "_operation": typeExport._Registration,
            "mode": typeExport._RegisterMode,
            "lang": i18n.locale,
            "firstname": FirstName.value,
            "lastname": LastName.value,
            "password": Password.value,
            "NationalCode": Tools.persianToEnglish(NationalCode.value),
            // "NationalCode":NationalCode.value,
            "ConfirmPassword": ConfirmPassword.value,
            "private": checked ? "1" : "0",
            "gender": this.state.indexSelectGender,
            "mobile": this.props.route.params.mobile ? this.props.route.params.mobile : this.state,
            "token_fb": this.props.DataSplashScreen.token_fb,

        };
        this.props.callService(
            typeExport.urlGetInformationScreen,
            // `?mobile=${this.props.route.params.mobile}&name=${this.state.FirstName.value}&Password=${this.state.Password.value}`,
            paramss,
            typeExport.TypegetDataInformationScreen,
            "POST"
        );

    }

    checkInput() {
        let {FirstName, LastName, Password, ConfirmPassword, NationalCode} = this.state;

        let National_code = Tools.persianToEnglish(NationalCode.value)
        if (FirstName.value.trim().length <= 1) {
            HMAlert(
                i18n.t('constant.message'),
                i18n.t('constant.Check_First_name'),
                [
                    // {text: 'Ask me later', onPress: () => {}},
                    // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                    {text: i18n.t('constant.ok'), onPress: () => {}},
                ],
                {cancelable: true}
            )
            //    alert("نام و نام خانوادگی را وارد نمایید")
        } else {
            if (LastName.value.trim().length <= 1) {
                HMAlert(
                    i18n.t('constant.message'),
                    i18n.t('constant.Check_Last_name'),
                    [
                        // {text: 'Ask me later', onPress: () => {}},
                        // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                        {text: i18n.t('constant.ok'), onPress: () => {}},
                    ],
                    {cancelable: true}
                )
                //    alert("نام و نام خانوادگی را وارد نمایید")
            } else {


                if (Password.value.trim().length < 6) {
                    HMAlert(
                        i18n.t('constant.message'),
                        i18n.t('constant.checkPassword'),
                        [
                            // {text: 'Ask me later', onPress: () => {}},
                            // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                            {text: i18n.t('constant.ok'), onPress: () => {}},
                        ],
                        {cancelable: true}
                    )
                    //    alert("نام و نام خانوادگی را وارد نمایید")
                } else {
                    if (ConfirmPassword.value.trim().length < 6) {
                        HMAlert(
                            i18n.t('constant.message'),
                            i18n.t('constant.checkConfirmPassword'),
                            [
                                // {text: 'Ask me later', onPress: () => {}},
                                // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                {text: i18n.t('constant.ok'), onPress: () => {}},
                            ],
                            {cancelable: true}
                        )
                        //    alert("نام و نام خانوادگی را وارد نمایید")
                    } else {
                        if (ConfirmPassword.value === Password.value) {

                            if (National_code == null || National_code == '') {
                                this.getData();
                            } else {

                                Tools.check_national_code(National_code) ?
                                    this.getData()
                                    :
                                    HMAlert(
                                        i18n.t('constant.message'),
                                        i18n.t('constant.Check_NationalCode'),
                                        [
                                            // {text: 'Ask me later', onPress: () => {}},
                                            // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                            {text: i18n.t('constant.ok'), onPress: () => {}},
                                        ],
                                        {cancelable: true}
                                    )
                            }


                        } else {
                            HMAlert(
                                i18n.t('constant.message'),
                                i18n.t('constant.errorConfirmPassword'),
                                [
                                    // {text: 'Ask me later', onPress: () => {}},
                                    // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                    {text: i18n.t('constant.ok'), onPress: () => {}},
                                ],
                                {cancelable: true}
                            )
                        }
                    }
                }
            }
        }

    }

    _changeTextFirstName(text) {
        this.setState({
            FirstName: {
                value: text,
                error: ''
            }
        });
    }

    _changeTextNationalCode(text) {
        this.setState({
            NationalCode: {
                value: text,
                error: ''
            }
        });
    }

    _changeTextLastName(text) {
        this.setState({
            LastName: {
                value: text,
                error: ''
            }
        });
    }

    _changeTextInviteCode(text) {
        this.setState({
            ConfirmPassword: {
                value: text,
                error: ''
            }
        });
    }

    _changeTextPassword(text) {
        this.setState({
            Password: {
                value: text,
                error: ''
            }
        });
    }

    _changeTextConfirmPassword(text) {
        this.setState({
            ConfirmPassword: {
                value: text,
                error: ''
            }
        });
    }

    _checkDisplay(field) {
        return {display: field === '' ? 'none' : 'flex'}
    }

    render() {
        const nameError = this.state.FirstName.error;
        const PasswordError = this.state.Password.error;
        let checkLogin = (store.getState().reducerSplashGetAllData.TypeLogin == 2)

        return (
            <View style={{position: 'relative', flex: 1}}>

                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{flex: 1,}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        <View style={{flex: 1,}}>
                            <HMActionBar
                                props={this.props} statusBarTransparent
                                text={i18n.t('Information.title')}

                                //  text={i18n.t('constant.Information')}
                                menu={!checkLogin}
                                back
                                headerVisibility more_menu
                                onBackPress={() => this.props.navigation.pop()}

                            />
                            <ScrollView
                                keyboardShouldPersistTaps="handled"
                                style={{flex: 1}}>


                                <HMTextInputEfects
                                    value={this.state.FirstName.value}

                                    type={"Fumi"}
                                    label={i18n.t('constant.First_name')}
                                    onChangeText={text => this._changeTextFirstName(text)}
                                    iconClass={"FontAwesome"}
                                    iconName={'user'}
                                    styleRoot={{
                                        width: "100%", alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                    // secureTextEntry={true}
                                />

                                <HMTextInputEfects
                                    type={"Fumi"}
                                    value={this.state.LastName.value}

                                    label={i18n.t('constant.Last_name')}
                                    onChangeText={text => this._changeTextLastName(text)}
                                    iconClass={"FontAwesome"}
                                    iconName={'users'}
                                    styleRoot={{
                                        width: "100%", alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                    //   secureTextEntry={true}
                                />
                                <View style={{flexDirection: 'row',marginHorizontal:moderateScale(30),alignItems:'center',marginTop: moderateScale(18),}}>

                                    <TouchableOpacity
                                        style={{flexDirection:'row',alignItems:'center',justifyContent:'center',height:moderateScale(34)}}
                                        onPress={() => {
                                            this.setState({
                                                indexSelectGender: 1
                                            })
                                        }}>
                                        <View style={{
                                            width: moderateScale(24),
                                            height: moderateScale(24),
                                            backgroundColor:'#ffffff',
                                            borderRadius:moderateScale(12),
                                            alignItems:'center',justifyContent:'center',

                                        }}>
                                        <Image
                                            source={this.state.indexSelectGender === 1 ? PathFile.image.Check : null}
                                            //resizeMode="stretch"
                                            style={[{}, {


                                                width: moderateScale(18),
                                                height: moderateScale(18),
                                            }]}/>
                                        </View>
                                        <HMTextView
                                          //  numberOfLines={1}
                                            // type={'bold'}
                                            text={i18n.t('constant.Man')}
                                            style={{

                                                color: Colors.blackLight,
                                                // marginEnd: moderateScale(10),
                                                fontSize: moderateScale(14),
                                                textAlign:'center',
                                                marginHorizontal:moderateScale(8)

                                            }}/>
                                    </TouchableOpacity>
                                    <View style={{width: moderateScale(20)}}/>
                                    <TouchableOpacity

                                        style={{flexDirection:'row',alignItems:'center',justifyContent:'center',height:moderateScale(34)}}
                                        onPress={() => {

                                            this.setState({
                                                indexSelectGender: 0
                                            })
                                        }}>
                                        <View style={{
                                            width: moderateScale(24),
                                            height: moderateScale(24),
                                            backgroundColor:'#ffffff',
                                            borderRadius:moderateScale(12),
                                            alignItems:'center',justifyContent:'center',

                                        }}>
                                        <Image
                                            source={this.state.indexSelectGender === 0 ? PathFile.image.Check : null}
                                            //resizeMode="stretch"
                                            style={[{}, {
                                               // backgroundColor:'#dcdcdc',
                                             //   borderRadius:moderateScale(9),
                                             //   borderRadius:moderateScale(9),
                                                width: moderateScale(18),
                                                height: moderateScale(18),
                                            }]}/>
                                        </View>
                                        <HMTextView
                                          //  numberOfLines={1}
                                            // type={'bold'}
                                            text={i18n.t('constant.Woman')}
                                            style={{
                                                color: Colors.blackLight,
                                                // marginEnd: moderateScale(10),
                                                fontSize: moderateScale(14),
                                                textAlign:'center',
                                                marginHorizontal:moderateScale(8)

                                            }}/>
                                    </TouchableOpacity>


                                </View>
                                <HMTextInputEfects
                                    type={"Fumi"}
                                    value={this.state.NationalCode.value}

                                    label={i18n.t('constant.NationalCode')}
                                    onChangeText={text => this._changeTextNationalCode(text)}
                                    iconClass={"FontAwesome"}
                                    iconName={'vcard'}
                                    styleRoot={{
                                        width: "100%", alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                    //   secureTextEntry={true}
                                />

                                <HMTextInputEfects
                                    type={"Fumi"}
                                    value={this.state.Password.value}

                                    label={i18n.t('constant.password')}
                                    onChangeText={text => this._changeTextPassword(text)}
                                    iconClass={"FontAwesome"}
                                    iconName={'lock'}
                                    secureTextEntry={true}
                                    styleRoot={{
                                        width: "100%", alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                />

                                <HMTextInputEfects
                                    type={"Fumi"}
                                    value={this.state.ConfirmPassword.value}

                                    label={i18n.t('constant.ConfirmPassword')}
                                    onChangeText={text => this._changeTextConfirmPassword(text)}
                                    iconClass={"FontAwesome"}
                                    iconName={'lock'}
                                    secureTextEntry={true}
                                    styleRoot={{
                                        width: "100%", alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                />
                                {/*       <TouchableOpacity
                                    onPress={()=>  this.setState({

                                        //     address: !this.state.checked ? "من در رستوران غذا را تحویل میگیرم" : this.props.user.address,
                                        checked: !this.state.checked,
                                    })}

                                    style={{
                                        flexDirection: "row",
                                       // alignSelf: "flex-end",
                                        marginHorizontal: moderateScale(18),
                                        marginTop: moderateScale(8)
                                    }}>
                                    <CheckBox
                                        color={ !this.state.checked ? Colors.colorDark : Colors.red}
                                        checked={this.state.checked} onPress={(check) => {


                                        this.setState({
                                            checked: !this.state.checked,
                                        })


                                    }}/>
                                    <View style={{width:moderateScale(15)}}/>
                                    <View
                                        >
                                        <HMTextView
                                            text="اطلاعاتم بصورت محرمانه باشد"
                                            style={{color: !this.state.checked ? Colors.colorDark : Colors.red}}
                                        />
                                    </View>

                                </TouchableOpacity>*/}

                                {/*  <BoldTextView textt="نام و نام خانوادگی"

                                          selfStyle={{
                                              marginEnd: moderateScale(10),
                                              color: colorPrimaryDark,
                                              fontSize: moderateScale(15),
                                              textAlign: "right"
                                          }}/>

                            <HMTextInput
                                value={this.state.FirstName.value}
                                onChangeText={text => this._changeTextFirstName(text)} autoFocus
                                textContentType="telephoneNumber" placeholder="نام خود را وارد نمایید" style={{
                                width: "90%",
                                fontFamily: "IRANSansMobile",
                                fontSize: moderateScale(14)
                            }} underlineColorAndroid="transparent"/>
                            <BoldTextView textt={i18n.t('constant.address')} selfStyle={{
                                color: colorPrimaryDark,
                                fontSize: moderateScale(15),
                                textAlign: "right",
                                marginTop: moderateScale(10)
                            }}/>

                            <HMTextInput
                                value={this.state.Password.value}
                                onChangeText={text => this._changeTextPassword(text)}
                                autoFocus
                                placeholder="آدرس خود را وارد نمایید (حداقل ۱۰ کاراکتر)"
                                style={{
                                    width: "90%",
                                    fontFamily: "IRANSansMobile",
                                    fontSize: moderateScale(14)
                                }}
                                _multiline
                                _height={80}
                                underlineColorAndroid="transparent"/>*/}
                                {/*<TextView textt={i18n.t('constant.MustContainOneCharacter')}*/}
                                {/*selfStyle={[InputStyles.error, this._checkDisplay(nameError)]}/>*/}
                                {/*<BoldTextView textt={i18n.t('constant.address')} selfStyle={{*/}
                                {/*marginEnd: moderateScale(10),*/}
                                {/*marginTop: moderateScale(10),*/}
                                {/*color: colorPrimaryDark,*/}
                                {/*fontSize: moderateScale(15),*/}
                                {/*textAlign: "right",*/}


                                {/*}}/>*/}
                                {/*<HMTextInput*/}
                                {/*value={this.state.Password.value}*/}
                                {/*onChangeText={text => this._changeTextPassword(text)}*/}
                                {/*placeholder="آدرس خود را وارد نمایید (حداقل ۱۰ کاراکتر)" _multiline _height={80} styles={{*/}
                                {/*marginStart: moderateScale(10),*/}
                                {/*width: "80%",*/}

                                {/*fontFamily: "IRANSansMobile",*/}
                                {/*fontSize: moderateScale(14)*/}
                                {/*}} underlineColorAndroid="transparent"/>*/}

                                {/*<TextView textt={i18n.t('constant.MustContainOneCharacter')}*/}
                                {/*selfStyle={[InputStyles.error, this._checkDisplay(PasswordError)]}/>*/}
                                {/* <BoldTextView textt="کد معرف" selfStyle={{
                                marginEnd: moderateScale(10),
                                color: colorPrimaryDark,
                                fontSize: moderateScale(15),
                                textAlign: "right",
                                marginTop: moderateScale(10)
                            }}/>

                            <HMTextInput
                                value={this.state.ConfirmPassword.value}
                                onChangeText={text => this._changeTextInviteCode(text)} autoFocus
                                textContentType="telephoneNumber" placeholder="کد معرف را وارد نمایید" style={{
                                width: "90%",
                                fontFamily: "IRANSansMobile",
                                fontSize: moderateScale(14)
                            }} underlineColorAndroid="transparent"/>*/}


                                {/*<AnimateLoadingButton*/}
                                {/*ref={c => (this.loadingButton = c)}*/}
                                {/*width={moderateScale(300)}*/}
                                {/*height={verticalScale(50)}*/}
                                {/*title=i18n.t('constant.Register')*/}
                                {/*titleFontFamily={Constants.regularFontName}*/}
                                {/*containerStyle={{marginTop: moderateScale(20)}}*/}
                                {/*titleFontSize={moderateScale(16)}*/}
                                {/*titleColor="rgb(255,255,255)"*/}
                                {/*backgroundColor={Colors.colorPrimary}*/}
                                {/*borderRadius={4}*/}

                                {/*onPress={() => this.checkInput()}*/}
                                {/*/>*/}
                                <TouchableOpacity style={{
                                    backgroundColor: Colors.colorPrimary,
                                    width: "93%",
                                    height: moderateScale(40),
                                    alignSelf: 'center',
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginTop: moderateScale(10),
                                    borderRadius: moderateScale(6)
                                    // borderRadius:moderateScale(2)
                                }}
                                                  onPress={() => this.checkInput()}
                                >
                                    <View
                                        style={{flexDirection: "row", alignItems: "center", justifyContent: "center"}}>
                                        <HMTextView type={"bold"} text={i18n.t('constant.Register')} style={{
                                            color: "white",
                                            fontSize: moderateScale(16),
                                        }}/>

                                    </View>
                                </TouchableOpacity>
                            </ScrollView>
                        </View>
                    </KeyboardAvoidingView>
                </View>

                {
                    this.props.NoInternetDialog ?
                        <DialogConnectionCustomize
                            onPress={() => this.checkInput()}
                        />
                        :
                        null
                }
                {
                    this.props.isLoading ?
                        <DialogLoadingCustomize/>
                        : null
                }
            </View>
        );
    }
}
